import { render, staticRenderFns } from "./FrzPalletChange.vue?vue&type=template&id=6ac44b26"
import script from "./FrzPalletChange.vue?vue&type=script&lang=js"
export * from "./FrzPalletChange.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports